<template>
   <v-select
        :items="partners"
        box
        :value="value"
        item-text="wo_partner_name"
        @change="handleChange"
        item-value="wo_partner_name"
        multiple
        :label="label[$i18n.locale]"></v-select>
</template>

<script>
import { mapGetters } from 'vuex'
	import Enumerable from 'linq'

export default {
    props: ['value', 'label'],
    computed: {
        ...mapGetters([
            'reportingData',
            'season'
        ]),
        partners: function () {
				if (this.reportingData.length > 0 && this.season) {
					// let result = this.reportingData
					const result = Enumerable.from(this.reportingData)
							.groupBy(`{Label: $.wo_partner_name }`, null, (key, g) => {
								return {
									wo_partner_name: key.Label
								}
							}, '$.Label')
							.orderBy('$.wo_partner_name')
							.select('$.wo_partner_name')
							.toArray()
					this.eventGroup = result[0]
					return result
				} else {
					return []
				}
			},
	},
    data() {
        return {}
    },
	methods: {
        handleChange (e) {
            this.$emit('input', e)
        }
	}
};
</script>
